/* The progress bar is pure CSS (.cs-row[data-active] .cs-progress over --cs-interval). */
if (!customElements.get('category-showcase')) {
  class CategoryShowcase extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('[data-cs-row]'));
      if (!this.rows.length) return;
      this.parts = Array.from(this.querySelectorAll('[data-index]'));
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.index = -1;
      this.paused = false;

      this.rows.forEach((row, i) => {
        row.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') this.activate(i);
        });
        row.addEventListener('focusin', () => this.activate(i));
        const link = row.querySelector('[data-cs-link]');
        // Touch has no hover: the first tap activates the row, the second navigates.
        link?.addEventListener('click', (e) => {
          if (i !== this.index) {
            e.preventDefault();
            this.activate(i);
          }
        });
      });

      // Hidden tabs freeze transitions and we drop the timer, so on return
      // re-activate the current row: bar and countdown restart together.
      this.onVisibility = () => (document.hidden ? this.stop() : this.activate(this.index));
      document.addEventListener('visibilitychange', this.onVisibility);

      if (window.Shopify?.designMode) {
        this.onBlockSelect = (e) => {
          const i = this.rows.indexOf(e.target);
          if (i < 0) return;
          this.paused = true;
          this.activate(i);
        };
        this.onBlockDeselect = (e) => {
          if (!this.rows.includes(e.target)) return;
          this.paused = false;
          this.start();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      this.activate(0);
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }

    activate(i) {
      this.index = i;
      this.parts.forEach((el) => el.removeAttribute('data-active'));
      // Reflow so a re-activated row's bar transition restarts from 0.
      void this.offsetWidth;
      this.parts.forEach((el) => {
        if (parseInt(el.dataset.index, 10) === i) el.setAttribute('data-active', '');
      });
      this.start();
    }

    start() {
      this.stop();
      if (this.paused || document.hidden) return;
      this.timer = setTimeout(() => this.activate((this.index + 1) % this.rows.length), this.interval);
    }

    stop() {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
  customElements.define('category-showcase', CategoryShowcase);
}
